<template>
	<div class="hq_tr">
	    <div
	      v-for="(item,i) in theadN"
				:key="'t_' + i"
	      :class="['hq_th', 'thead_' + item.key,item.sort ? 'th_sort' : '', item.class]"
	      :thead-key="item.key"
	      :style="{width: getTdWidth(item)}"
	      @click="$parent.handleSort(item)">
	        <span>{{ item.name }}</span>
	        <span v-if="sort && item.key === sort.key" :class="['hqicon', 'hqicon-sort-' + sort.type]"></span>
	      </div>
	</div>
</template>

<script>
	import Util from './util'
	export default {
		name: 'hqthead',
		props: ['theadN', 'sort'],
		methods: {
			getTdWidth: Util.getTdWidth
		}
	}
</script>


// WEBPACK FOOTER //
// src/lib/v-hqtable/lib/thead.vue